

const FLAGS = {
	CA:<span className="fi fi-ca" key="fi-ca"></span>,
	DE: <span className="fi fi-de" key="fi-de"></span>,
	GB_ENG: <span className="fi fi-gb-eng" key="fi-gb-eng"></span>,
	GB_WLS: <span className="fi fi-gb-wls" key="fi-gb-wls"></span>,
	GB_SCOT: <span className="fi fi-gb-sct" key="fi-gb-sct"></span>,
	IE: <span className="fi fi-ie" key="fi-ie"></span>,
	USA: <span className="fi fi-us" key="fi-us"></span>,
};


function GoverningBodyFlag({ governingBody, style, padRight, padLeft }) {
	if(!governingBody) {
		return null;
	}

	let governingBodyFlags = [];
	switch(governingBody) {
		case 'CA_IWLS':
		case 'CA_WSC':
			governingBodyFlags.push(FLAGS.CA);
			break;
		case 'EA':
			governingBodyFlags.push(FLAGS.GB_ENG);
			break;
		case 'NRW':
			governingBodyFlags.push(FLAGS.GB_WLS);
			break;
		case 'SEPA':
			governingBodyFlags.push(FLAGS.GB_SCOT);
			break;
		case 'EA+NRW':
			governingBodyFlags.push(FLAGS.GB_ENG);
			governingBodyFlags.push(FLAGS.GB_WLS);
			break;
		case 'EA+SEPA':
			governingBodyFlags.push(FLAGS.GB_ENG);
			governingBodyFlags.push(FLAGS.GB_SCOT);
			break;
		case 'IE_EPA':
		case 'IE_OPW':
			governingBodyFlags.push(FLAGS.IE);
			break;
		case 'USA_USGS':
			governingBodyFlags.push(FLAGS.USA);
			break;
		case 'DE_FGG_DONAU':
		case 'DE_FGG_ELBE':
		case 'DE_FGG_EMS':
		case 'DE_FGG_RHEIN':
		case 'DE_FS_MV':
		case 'DE_FS_SH':
		case 'DE_PO':
			governingBodyFlags.push(FLAGS.DE);
			break;
	}
	
	return <span style={style}>{padLeft ? " " : ""}{governingBodyFlags}{padRight ? " " : ""}</span>;
}

export default GoverningBodyFlag;